import $ from "./main"
import Cookies from 'js-cookie'

function setDimensionByCookie() {
	if(Cookies.get('dimensionSwitch') == 'metric'){
		$(".js-dimensions--metric").removeClass("visuallyhidden");
		if(!$(".js-dimensions--imperial").hasClass("visuallyhidden")){
			$(".js-dimensions--imperial").addClass("visuallyhidden");
		}
		$(".js-dimension-switch").prop("checked", false);
	} else if(Cookies.get('dimensionSwitch') == 'imperial'){
		$(".js-dimensions--imperial").removeClass("visuallyhidden");
		if(!$(".js-dimensions--metric").hasClass("visuallyhidden")){
			$(".js-dimensions--metric").addClass("visuallyhidden");
		}
		$(".js-dimension-switch").prop("checked", true);
	}

}

$(document).ready(function ($) {	// generic PJAX anchor

	if(typeof Cookies.get('dimensionSwitch') === "undefined") {
		Cookies.set('dimensionSwitch', 'metric')
	}

	setDimensionByCookie();
	$(".js-dimension-switch").on("change", function (e) {
		if($(this).prop("checked")) {
			Cookies.set('dimensionSwitch', 'imperial')
		} else {
			Cookies.set('dimensionSwitch', 'metric')
		}
		setDimensionByCookie();
	})

	if ($.support.pjax) {
		$.pjax.defaults.timeout = 3000;

		$(document).on('click', '.js-size-slug', function (event) {
			$('.js-size-slug').removeClass('is-active');
			$(this).addClass('is-active');
			$.pjax.click(event, {
				scrollTo: false,
				container: '#js-sizes-container',
				fragment: '#js-sizes-container'
			})
		});

		$('#js-sizes-container').on('pjax:send', function (xhr, options, event) {
			$('#js-sizes-container .sizes-detail__content').prepend('<span class="loading">Loading</span>');
		});

		$('#js-sizes-container').on('pjax:complete', function (xhr, options, event) {
			setTimeout(function() {
				initLazyLoad();
			}, 800);
		});


	}
});
